import React, { SVGProps } from 'react';

export const Minimize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.498 1.2H8.7C8.683 8.33 8.275 8.685 1.2 8.7v1.798c8.22-.043 9.255-1.078 9.298-9.298M1.2 15.3v-1.799c8.22.044 9.255 1.079 9.298 9.299H8.7c-.016-7.13-.424-7.486-7.499-7.5M15.3 22.8c.017-7.13.425-7.486 7.5-7.5v-1.799c-8.22.044-9.255 1.079-9.298 9.299zM22.8 10.498c-8.22-.043-9.255-1.078-9.298-9.298H15.3c.016 7.13.424 7.485 7.499 7.5z"
    />
  </svg>
);
